export {CustomerModule} from './customerModule';
